import Link from 'next/link';
import './Button.scss';

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  type?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ComponentType<{ size?: number }>;

  href?: string;
  disabled?: boolean;
}

export default function Button({
  children,
  type = 'primary',
  size = 'md',
  icon: Icon,
  href,
  onClick,
  disabled = false,
  className = '',
}: ButtonProps) {
  const baseClasses = 'btn';
  const typeClasses = {
    primary: 'btn-primary',
    outline: 'btn-outline',
    ghost: 'btn-ghost'
  };
  const sizeClasses = {
    sm: 'btn-small',
    md: '',
    lg: 'btn-large'
  };

  const classes = [
    baseClasses,
    typeClasses[type],
    sizeClasses[size],
    className
  ].filter(Boolean).join(' ');

  const content = (
    <>
      {Icon &&
        <span className="btn-icon">
          <Icon size={20} />
        </span>
      }
      {children}
    </>
  );

  if (href) {
    return (
      <Link href={href} className={classes}>
        {content}
      </Link>
    );
  }

  return (
    <button
      className={classes}
      onClick={onClick}
      disabled={disabled}
    >
      {content}
    </button>
  );
}